import VisaCardIcon from './VisaCardIcon';

export default VisaCardIcon;
